import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'assuredtechmatics',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/assuredtechmatics/light-logo.svg',
    darkLogo: 'assets/assuredtechmatics/dark-logo.svg',
    alt: 'Assured Techmatics',
    width: '60px',
    height: '32px',
    loginPageWidth: '40px',
    loginPageHeight: '40px',
  },
  showCustomLoginPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
